import { render, staticRenderFns } from "./addUpload.vue?vue&type=template&id=35601a5a&scoped=true&"
import script from "./addUpload.vue?vue&type=script&lang=js&"
export * from "./addUpload.vue?vue&type=script&lang=js&"
import style0 from "./addUpload.vue?vue&type=style&index=0&id=35601a5a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35601a5a",
  null
  
)

export default component.exports